import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const HomeIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg viewBox="0 -960 960 960" >
				<g fill="currentColor">
				    <path d="M220-180h150v-250h220v250h150v-390L480-765 220-570v390Zm-60 60v-480l320-240 320 240v480H530v-250H430v250H160Zm320-353Z"/>
				</g>
			</svg>
		</Icon>
    )
}

export default HomeIcon;